import * as React from "react";
type Props = {
  className?: string,
};
function SvgTablesetting({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Table setting"
      className={className}
    >
      <path
        d="M20.3543 29.9932C26.1053 29.9932 30.7675 25.4426 30.7675 19.8292C30.7675 14.2157 26.1053 9.66516 20.3543 9.66516C14.6032 9.66516 9.94104 14.2157 9.94104 19.8292C9.94104 25.4426 14.6032 29.9932 20.3543 29.9932Z"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M6.66201 13.5311C6.66201 11.3971 5.4197 9.67206 3.88646 9.67206C2.35323 9.67206 1.11108 11.3971 1.11108 13.5311C1.11108 15.4156 2.0835 16.9954 3.3683 17.3211C2.65847 22.3996 1.89188 30 3.92909 30C5.583 30 4.97962 22.379 4.43305 17.3143C5.70364 16.961 6.66201 15.4017 6.66201 13.5311Z"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M36.9517 9.39496V14.5705"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M34.9561 14.9169H38.9524"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M20.355 25.2749C23.4364 25.2749 25.9343 22.8368 25.9343 19.8292C25.9343 16.8216 23.4364 14.3834 20.355 14.3834C17.2737 14.3834 14.7758 16.8216 14.7758 19.8292C14.7758 22.8368 17.2737 25.2749 20.355 25.2749Z"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M3.88652 17.3904C5.41936 17.3904 6.66196 15.6626 6.66196 13.5313C6.66196 11.3999 5.41936 9.67212 3.88652 9.67212C2.35369 9.67212 1.11108 11.3999 1.11108 13.5313C1.11108 15.6626 2.35369 17.3904 3.88652 17.3904Z"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M36.4466 17.3904C35.7368 22.469 34.9915 30 37.0145 30C38.6614 30 38.0722 22.4343 37.5256 17.3904H36.4466Z"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M34.9487 9.50598V16.6283C34.9487 16.732 34.9698 16.8345 35.0104 16.9304C35.0511 17.0262 35.1107 17.1135 35.1858 17.1868C35.2609 17.2601 35.3502 17.3183 35.4483 17.358C35.5465 17.3977 35.6518 17.4182 35.758 17.4182H38.143C38.3526 17.411 38.5513 17.3247 38.697 17.1773C38.8427 17.03 38.924 16.833 38.9238 16.6283V9.53338"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
    </svg>
  );
}
export default SvgTablesetting;
